/**
 * @fileoverview Value Interpolator - 値補間ロジック（RAF なし）
 * 時間源は外部から注入される（update(nowMs)）
 */

export function createInterpolator(options) {
  let startMs = 0;
  let running = false;
  let currentValue = options.from;
  let progress = 0;

  const { from, to, durationMs, easingFn } = options;

  return {
    start(nowMs) {
      if (running) return;
      startMs = nowMs;
      running = true;
      currentValue = from;
      progress = 0;
    },

    update(nowMs) {
      if (!running) return false;

      const elapsed = nowMs - startMs;
      const t = Math.min(1, elapsed / durationMs);
      progress = easingFn(t);
      currentValue = from + (to - from) * progress;

      if (t >= 1) {
        running = false;
        currentValue = to;
        progress = 1;
        return false;
      }

      return true;
    },

    stop() {
      running = false;
    },

    isRunning() {
      return running;
    },

    getValue() {
      return currentValue;
    },

    getProgress() {
      return progress;
    },
  };
}

export const easings = {
  linear: (t) => t,
  cubicOut: (t) => 1 - Math.pow(1 - t, 3),
  quadOut: (t) => 1 - Math.pow(1 - t, 2),
};
